/* Packages */
import React from 'react';
import {render} from 'react-dom';

/* Helpers */
import {parseDataToProps} from '../helpers';

const productCompareNodes = document.querySelectorAll('.product-compare');
if (productCompareNodes.length > 0) {
    import(/* webpackChunkName: "ProductCompareView" */ './components/ProductCompareView').then(({ObservingProductCompare: ObservingProductCompare}) => {
        [...productCompareNodes].forEach((node) => render(
            <ObservingProductCompare {...parseDataToProps(node.dataset)} />, node));
    });
}
const compareMailNodes = document.querySelectorAll('.compare-mail');
if (compareMailNodes.length > 0) {
    import(/* webpackChunkName: "CompareMail" */ './components/CompareMail').then(({default: CompareMail}) => {
        [...compareMailNodes].forEach((node) => render(<CompareMail {...parseDataToProps(node.dataset)} />, node));
    });
}
